export const validateImageFiles = ({ files }) => {
  console.log(files);

  let errorMessage = "";
  if (files.length === 0) {
    errorMessage = "At least one image is required.";
  } else {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.size > 2 * 1024 * 1024) {
        errorMessage = "Each image must be less than 2MB.";
        break;
      }
      if (
        file.type &&
        !(file.type === "image/jpeg" || file.type === "image/jpg")
      ) {
        errorMessage = "Only JPG images are allowed.";
        break;
      }
    }
  }
  return errorMessage;
};
